import { Text } from '@thanx/uikit/text'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'

// Vertical gap ConfigCard applies between its own direct children (the
// title/subtitle block and whatever `children` renders) via its outer flex
// column. Exported so a consumer that renders a ConfigCard's children
// OUTSIDE the card (EscalationRulesPane, AI-903) can reproduce the same
// inter-section rhythm instead of duplicating the '24px' literal.
export const CONFIG_CARD_GAP = '24px'

type Props = {
  title: React.ReactNode
  subtitle?: string
  editLabel?: string
  onEdit?: () => void
  children: React.ReactNode
}

const ConfigCard = ({
  title,
  subtitle,
  editLabel,
  onEdit,
  children,
}: Props) => {
  const [css] = useStyletron()

  return (
    <div
      className={`d-flex flex-column ${css({
        backgroundColor: 'white',
        border: `1px solid ${merchantTheme.colors.grey20}`,
        borderRadius: '4px',
        padding: '24px',
        gap: CONFIG_CARD_GAP,
      })}`}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex flex-column">
          <Text.Header4 bold>{title}</Text.Header4>
          {subtitle && (
            <Text.BodyText3 color="grey70" className="mt-xs">
              {subtitle}
            </Text.BodyText3>
          )}
        </div>
        {onEdit && editLabel && (
          <button
            type="button"
            className={css({
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            })}
            onClick={onEdit}
          >
            <Text.BodyText3 bold color="belizeHole50">
              {editLabel}
            </Text.BodyText3>
          </button>
        )}
      </div>
      {children}
    </div>
  )
}

export default ConfigCard
